//Prefixes
import { asArray } from '@nu-art/ts-common';
export const IDGeneratorPrefix_State = 'state-';
export const IDGeneratorPrefix_Transition = 'transition-';
export const IDGeneratorPrefix_TransitionPoint = 'transition-point-';
const IDGeneratorPrefixes = [IDGeneratorPrefix_State, IDGeneratorPrefix_Transition, IDGeneratorPrefix_TransitionPoint];
//Suffixes
export const IDGeneratorSuffix_Start = '-start';
export const IDGeneratorSuffix_End = '-end';
const IDGeneratorSuffixes = [IDGeneratorSuffix_Start, IDGeneratorSuffix_End];
export const updateOnSync = (pathwayId, params, keyToCompare, updateCallback, deleteCallback) => {
    if (params[0] === 'delete' || params[0] === 'delete-multi')
        return deleteCallback();
    const changedPathwayTransitions = asArray(params[1]);
    if (changedPathwayTransitions.some(transition => asArray(transition[keyToCompare]).includes(pathwayId)))
        updateCallback();
};
// svg loader
export const getGraphLoader = (rect) => {
    const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const _rect = rect.cloneNode();
    const innerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    const outerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    const animation = document.createElementNS('http://www.w3.org/2000/svg', 'animateTransform');
    // calculate loader location (x,y)
    const rectWidth = Number(rect.getAttribute('width'));
    const rectHeight = Number(rect.getAttribute('height'));
    const rectX = rect.getAttribute('x');
    const rectY = rect.getAttribute('y');
    const centerX = parseFloat(rectX) + rectWidth / 2;
    const centerY = parseFloat(rectY) + rectHeight / 2;
    // create inner circle
    innerCircle.setAttribute('cx', centerX.toString());
    innerCircle.setAttribute('cy', centerY.toString());
    innerCircle.setAttribute('r', '12');
    innerCircle.setAttribute('fill', 'none');
    innerCircle.setAttribute('stroke', 'rgba(0, 0, 0, 0.08)');
    innerCircle.setAttribute('stroke-width', '4');
    // create outer circle
    outerCircle.setAttribute('cx', centerX.toString());
    outerCircle.setAttribute('cy', centerY.toString());
    outerCircle.setAttribute('r', '12');
    outerCircle.setAttribute('fill', 'none');
    outerCircle.setAttribute('stroke-width', '4');
    outerCircle.setAttribute('stroke', '#0054F7');
    outerCircle.setAttribute('stroke-dasharray', '65');
    outerCircle.setAttribute('stroke-dashoffset', '75');
    // add animation
    animation.setAttribute('attributeName', 'transform');
    animation.setAttribute('type', 'rotate');
    animation.setAttribute('from', `0 ${centerX} ${centerY}`);
    animation.setAttribute('to', `360 ${centerX} ${centerY}`);
    animation.setAttribute('dur', '1s');
    animation.setAttribute('repeatCount', 'indefinite');
    group.classList.add('graph-loader');
    _rect.style.fill = 'rgba(248,248,255,0.89)';
    group.appendChild(_rect);
    group.appendChild(innerCircle);
    outerCircle.appendChild(animation);
    group.appendChild(outerCircle);
    return group;
};
//# sourceMappingURL=util.js.map